import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../axiosInstance";

export const userLoginApi = createAsyncThunk(
  "login/userLoginApi",
  async ({ email, password }, { rejectWithValue }) => {
    try {
     
      const response = await axiosInstance.post("/auth/login/", {
        email,
        password,
      
      });

      // Save tokens to localStorage

      return response.data;
      // Return the entire response for further usage
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const getAuthHeaders = () => {
  const token = localStorage.getItem("accessToken");

  if (!token) {
    throw new Error("Access token is missing. Please log in again.");
  }
  return {
    Authorization: `Bearer ${token}`,
  };
};

export const userForgotPasswordApi = createAsyncThunk(
  "login/userForgotPasswordApi",
  async ({ email }, { rejectWithValue }) => {
    // Accept email and password as arguments

    try {
      const response = await axiosInstance.post(
        "/auth/forgotpassword/", // Ensure getAuthHeaders() includes the correct token
        {
          // Use POST to send data
          email,
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);




export const userOtpVerificationApi = createAsyncThunk(
  "login/userOtpVerificationApi",
  async ({ email, otp }, { rejectWithValue }) => {
    // Accept email and password as arguments
    try {
      const response = await axiosInstance.post("/auth/forgotpassword-otp/", {
        // Use POST to send data
        email: email,
        otp: otp,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

//reset password Api
export const userResetPasswordApi1 = createAsyncThunk(
  "login/userResetPasswordApi",
  async ({ email, new_password }, { rejectWithValue }) => {
    try {
    
      const response = await axiosInstance.post(
        "/auth/reset-password/",
        { email, new_password },
    
      );

    
      return response.data;
    } catch (error) {
      console.error("Error Object:", error);
      console.error("Error Response:", error.response);
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);


export const userResetPasswordApi = createAsyncThunk(
  "login/userResetPasswordApi",
  async ({ email, new_password ,old_password }, { rejectWithValue }) => {
    try {
    
      const response = await axiosInstance.post(
        "/auth/resetpassword/",
        { email, new_password ,old_password},
        { headers: getAuthHeaders() }
      );

   
      return response.data;
    } catch (error) {
      console.error("Error Object:", error);
      console.error("Error Response:", error.response);
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);


 export const getUserDetailsApi=async(userId)=>{

    try {
         const response =axiosInstance.get(`/auth/provider/${userId}`)
         return response;
    } catch (error) {
         console.error("Error getting user details ", error);
         throw error;
    }
 
 
 }
